import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ProposalPage from './pages/ProposalPage/ProposalPage';
import AliasRedirect from './pages/AliasRedirect/AliasRedirect';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/proposal/:token" element={<ProposalPage />} />
        {/* Short links with no `proposal` segment (e.g. /12, /NOB-12) → resolve to the proposal URL */}
        <Route path="/:alias" element={<AliasRedirect />} />
        <Route path="/" element={<Navigate to="/proposal/MzVfMTg0" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
